import { AffiliateProduct } from "@sphtech/dmg-design-system";
import { ReactElement } from "react";

import styles from "./product.module.css";

type AffiliatesProduct = React.ComponentProps<typeof AffiliateProduct>;
type ProductsProps = {
  items: AffiliatesProduct["item"][];
  itemWidth?: AffiliatesProduct["itemWidth"];
  itemHeight?: AffiliatesProduct["itemHeight"];
  cta?: AffiliatesProduct["cta"];
  options: AffiliatesProduct["options"];
};

export default function Products({
  items,
  itemWidth,
  itemHeight,
  cta,
  options,
}: ProductsProps): ReactElement {
  const enforceDoublePriceLine = items.some((item) => {
    const { discountPrice, originalPrice } = item.dealsSource?.[0] || {};

    return discountPrice && originalPrice;
  });

  return (
    <div className={styles.contentProducts}>
      {items.map((item, index) => (
        <AffiliateProduct
          cta={cta}
          item={item}
          key={index}
          itemWidth={itemWidth}
          itemHeight={itemHeight}
          enforceDoublePriceLine={enforceDoublePriceLine}
          options={options}
        />
      ))}
    </div>
  );
}
